import { SharedAppEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedAppEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedAppEventsApi(configuration), [configuration]);
};
